module.exports = __webpack_public_path__ + "img/01.6fb8dbe2.png";